import Vue from 'vue'
import Vuetify from 'vuetify/lib'

import '@mdi/font/css/materialdesignicons.css'
import store from '@/stores'
import colors from 'vuetify/lib/util/colors'
import zhHans from 'vuetify/lib/locale/zh-Hans.js'

Vue.use(Vuetify);

export default new Vuetify({
  lang: {
    locales: { zhHans },
    current: 'zhHans'
  },
  icons: {
    iconfont: 'mdi'
  },
  theme: {
    dark: store.getters['settings/themeColor'].dark,

    //定义所有的主题样式
    themes: {
      light: {
        primary: store.getters['settings/themeColor'].primary,
        secondary: store.getters['settings/themeColor'].secondary,
        accent: store.getters['settings/themeColor'].accent,

        success: colors.green.lighten1,
        warning: colors.amber.accent3,
        error: colors.red.accent3
      },
      dark: {
        primary: store.getters['settings/themeColor'].primary,
        secondary: store.getters['settings/themeColor'].secondary,
        accent: store.getters['settings/themeColor'].accent,

        success: colors.green.lighten1,
        warning: colors.amber.accent3,
        error: colors.red.accent3
      }
    }
  }
})
